import { createLoadable } from '@main/core-ui';

// Load the component dynamically
// Routes for TCF Vendor Details, Vendor Purposes, and Vendor Features point to this Loadable
export const TcfVendorDetailsLoadable = createLoadable({
  loader: () => import('./TcfVendorDetails'),
});
